document.addEventListener('click', (e) => {

    // Références
    const referenceBtn = e.target.closest('.reference-card__read-more');

    if (referenceBtn) {
        const description = referenceBtn
            .closest('.reference-card__bottom')
            .querySelector('.reference-card__description');

        const isOpen = description.classList.toggle('is-open');

        referenceBtn.textContent = isOpen
            ? referenceBtn.dataset.closeLabel
            : referenceBtn.dataset.openLabel;

        return;
    }

    // Équipe
    const teamBtn = e.target.closest('.teams-list-single__button');

    if (teamBtn) {
        const content = teamBtn.previousElementSibling;

        const isOpen = content.classList.toggle('is-open');

        teamBtn.textContent = isOpen
            ? teamBtn.dataset.closeLabel
            : teamBtn.dataset.openLabel;
    }

});